import { render, staticRenderFns } from "./employee-avatar.component.vue?vue&type=template&id=f46d86be&scoped=true&"
import script from "./employee-avatar.component.vue?vue&type=script&lang=ts&"
export * from "./employee-avatar.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-avatar.component.vue?vue&type=style&index=0&id=f46d86be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d86be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
